export function formatRoundUp(value) {
  const transformValue = Math.round(value * 100) / 100;
  return `${transformValue} %`;
}
export function formatThousandths(value) {
  const valRound = Math.round(value);
  return `${valRound}`.replace(/\d{1,3}(?=(\d{3})+$)/g, (s) => `${s},`);
}
